<template>
    <a-modal title="温馨提示" :width="1000" :open="$store.state.indexPop.visible" @cancel="cancel" @ok="handleModalOk">
        呵呵哒={{ $store.state.indexPop.popupData }}
    </a-modal>
</template>
<script lang="ts" setup>
import { message, Modal } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import { reactive, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
const $store = useStore()

const formLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 10 }
    }
}
const ruleForm = ref()
const emit = defineEmits(['cancel', 'ok'])
const props = defineProps({
    detailData: {
        type: Object,
        default: () => { }
    }
})
interface IState {
    loading: boolean
}
const state = reactive<IState>({
    loading: false,
})
onMounted(() => {

})
const cancel = () => {
    $store.dispatch('indexPop/closePopup')
}
const handleModalOk = () => {
    $store.dispatch('indexPop/closePopup')
}
</script>

<style lang="less" scoped></style>
